// main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { installAuthStorageSync } from "@/api/auth-storage-sync.js";
import "./assets/styles/global.css";

const app = createApp(App);
const pinia = createPinia(); // 👈 必ずここで作る
app.use(pinia); // 👈 そしてここで登録
app.use(router);
app.mount("#app");
installAuthStorageSync({ pinia, router });
